import React from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  styled,
} from '@mui/material'
import popup_Styles from './popup.styles'

interface ApPopupAtomProps extends DialogProps {
  ap_name:
    | 'edit_location_cancel_popup'
    | 'location_too_far_popup'
    | 'notify_prefs_cancel_popup'
  renderTitle?: () => JSX.Element | JSX.Element[] | null
  renderContent?: () => JSX.Element | JSX.Element[] | null
  renderActions?: () => JSX.Element | JSX.Element[] | null
}

const apAtomName = {ap_atom_name: 'apPopupAtom'}

const StyledDialog = styled(Dialog)`
  ${popup_Styles}
`

const PopupAtom: React.FC<ApPopupAtomProps> = function ({
  open,
  renderTitle = () => null,
  renderContent = () => null,
  renderActions = () => null,
  ap_name,
}) {
  const title = renderTitle()
  const content = renderContent()
  const actions = renderActions()
  return (
    <StyledDialog {...apAtomName} ap_name={ap_name} open={open}>
      {title && <DialogTitle>{title}</DialogTitle>}
      {content && <DialogContent>{content}</DialogContent>}
      {actions && <DialogActions>{actions}</DialogActions>}
    </StyledDialog>
  )
}

PopupAtom.defaultProps = {
  renderTitle: () => null,
  renderContent: () => null,
  renderActions: () => null,
}

export default PopupAtom
